package org.lennycodes.hldi.constants

object RNInfo {
    val phone = listOf("+255 787 091 960","+255 755 662 788")
    val fax = "0282225052"
    val email = "info@rn-hldi.or.tz"
    val website = "www.rn-hldi.or.tz/"
    val regNo = "00NGO/R/8457"
    val address = "Plot No. 597 – 600, Mission Street, Biharamulo Urban\n" +
            "P.O. Box 107,\n" +
            "Biharamulo-Kagera\n"
}




